/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Show_BorderInputs */

const fr_label_show_border = /** @type {(inputs: Label_Show_BorderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bordures`)
};

const en_label_show_border = /** @type {(inputs: Label_Show_BorderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borders`)
};

/**
* | output |
* | --- |
* | "Borders" |
*
* @param {Label_Show_BorderInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_show_border = /** @type {((inputs?: Label_Show_BorderInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Show_BorderInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_show_border(inputs)
	return en_label_show_border(inputs)
});